export default {
  // Hero
  heroTitle: 'Arrive.\nBreathe.\nFeel at home.',
  heroSubtitle: 'Between Munich, Lake Starnberg, the Alps and a soothing sense of calm – a stay that begins easily and stays with you long after.',
  heroCtaPrimary: 'Book now',
  heroCtaSecondary: 'Discover our rooms',

  // Benefits
  benefitsTitle: 'At home from the very first moment.',
  benefitsLead: 'At Hotel Alpenhof, relaxation begins the moment you arrive. A warm atmosphere, a quiet setting and a house with character create exactly the feeling that makes a getaway special: alpine cosiness in an ideal location near Munich, with Lake Starnberg just around the corner.',
  benefit1Title: 'Quiet location',
  benefit1Text: 'A restorative atmosphere away from the bustle, set in the idyllic countryside of Gauting in the Würmtal valley.',
  benefit2Title: 'Close to Munich',
  benefit2Text: 'Excellent connections to the Bavarian capital by S-Bahn – ideal for sightseeing and business trips alike.',
  benefit3Title: 'Lake Starnberg',
  benefit3Text: 'Just minutes away from picturesque Lake Starnberg – the perfect starting point for exploring the waterfront.',
  benefit4Title: 'Charming rooms',
  benefit4Text: 'Lovingly furnished rooms with alpine charm and modern comfort for restful nights.',
  benefit5Title: 'A personal touch',
  benefit5Text: 'Warm hospitality and individual attention in a family-run setting – you are welcome here.',
  benefit6Title: 'Plenty to explore',
  benefit6Text: 'From Lake Ammersee to the Zugspitze – with Upper Bavaria right on the doorstep.',

  // Tradition
  tradKicker: 'About us',
  tradTitle: 'A house of calm and hospitality',
  tradLead: 'Today, Hotel Alpenhof in Gauting is a stylish hotel with alpine character – a place where guests from all over the world find peace and comfort. We combine our long-standing experience in hospitality with personal care and thoughtful details that make every stay in Gauting something special.',
  tradCtaButton: 'More about the hotel',
  tradGalleryTitle: 'Inside the house',
  tradGalleryLead: 'Discover the atmosphere of Hotel Alpenhof Gauting',

  // Rooms preview
  roomsPreviewTitle: 'Our rooms',
  roomsPreviewLead: 'Charming rooms with alpine character and modern comfort – your retreat for restful nights in Gauting between Munich and Lake Starnberg.',
  roomsPreviewKicker: 'Our rooms',
  roomsPreviewHeadline: 'The perfect place for a good night.',
  roomsPreviewCta: 'View rooms',

  // Excursions teaser
  exTeaserKicker: 'Things to do',
  exTeaserTitle: 'Today, the lake. Tomorrow, the city. The day after that, the Alps.',
  exTeaserLead: 'Discover the most beautiful places nearby. Around the Alpenhof, every day can feel different. Sometimes you head to the water, sometimes into town, sometimes towards the mountains. Much is close at hand – and much can be decided on a whim.',
  exTeaserCta: 'View all destinations',
  exTeaserSlide1Label: 'Culture & history',
  exTeaserSlide1Title: 'Nymphenburg Palace',
  exTeaserSlide1Desc: 'Baroque grandeur, sweeping parklands and royal history – just 35 minutes from Gauting.',
  exTeaserSlide1Duration: '35 min drive',
  exTeaserSlide2Label: 'Nature & mountains',
  exTeaserSlide2Title: 'The Alps',
  exTeaserSlide2Desc: 'Peaks, alpine meadows and crystal-clear mountain lakes – the Alps are only a glance away.',
  exTeaserSlide2Duration: '60 min drive',
  exTeaserSlide3Label: 'Nature & relaxation',
  exTeaserSlide3Title: 'Lake Ammersee',
  exTeaserSlide3Desc: 'Sailing boats, reed-lined shores and Andechs Monastery on the Holy Mountain – Lake Ammersee invites you to linger.',
  exTeaserSlide3Duration: '25 min drive',
  exTeaserSlide4Label: 'Nature & relaxation',
  exTeaserSlide4Title: 'Lake Starnberg',
  exTeaserSlide4Desc: 'Clear water, charming lakeside villages and an alpine panorama – Lake Starnberg is only 10 minutes away.',
  exTeaserSlide4Duration: '10 min drive',

  // Breakfast
  bfKicker: 'Breakfast & stay',
  bfTitlePart1: 'Live like the',
  bfTitleKini: 'Kini',
  bfTitlePart2: 'himself.',
  bfLead1: 'The day starts at the Alpenhof in a relaxed, unhurried way – with a delicious breakfast.',
  bfLead2: 'Our breakfast room radiates alpine cosiness and invites you to linger. In summer, the lovely garden beckons. Once you are well rested and well fed, the next stop might be Lake Starnberg, Munich or the mountains. Just ask us for tips and recommendations.',
  bfFeat1Title: 'High-quality produce',
  bfFeat1Text: 'Organic products from the Andechs dairy. Rolls and bread from the local organic bakery (voted Europe’s best bakery). And many more carefully chosen ingredients.',
  bfFeat2Title: 'Personal service',
  bfFeat2Text: 'Looking after our guests matters to us. Would you like your breakfast egg just the way you like it? A particular coffee or tea speciality? We are happy to take care of it.',
  bfFeat3Title: 'Round off the day',
  bfFeat3Text: 'With a glass of wine or beer in our cosy lounge with its traditional tiled stove, in the leafy garden, or browsing our own library for ideas for tomorrow’s excursions.',
  bfKiniKicker: 'King Ludwig II',
  bfKiniTitle: 'The fairy-tale king',
  bfKiniDates: '1845 – 1886',
  bfKiniText1: 'Probably Bavaria’s most famous king – builder of Neuschwanstein, Linderhof and Herrenchiemsee, dreamy, reclusive, a legend to this day.',
  bfKiniText2: 'Closely linked with our region: he spent much of his time at Berg Castle and met his mysterious end in Lake Starnberg. The Votive Chapel in Berg and the cross in the water still recall the story today.',
  bfKiniCta: 'In his footsteps through the region',

  // Location
  locKicker: 'Our location',
  locTitleLine1: 'Quiet setting.',
  locTitleLine2: 'Cleverly connected.',
  locLead: 'Gauting combines genuine calm with a wealth of possibilities. Lake Starnberg, Munich and the most beautiful corners of the region are pleasantly close.',
  locHL1Title: 'Gauting in the Würmtal',
  locHL1Text: 'A peaceful spot in the picturesque Würmtal valley, southwest of Munich – ideally reached both by car and by S-Bahn.',
  locHL2Title: 'Into Munich',
  locHL2Text: 'Just 25 minutes to Munich city centre – by car or by S-Bahn, with the station only a few minutes’ walk away.',
  locHL3Title: 'To Lake Starnberg',
  locHL3Text: 'Lake Starnberg is just a short drive away – perfect for walks, boat trips and excursions.',
  locHL4Title: 'To other lakes and the Alps',
  locHL4Text: 'Nearby you’ll find not only lakes like Ammersee, Wörthsee and Staffelsee, but also the mountains. The Zugspitze is reachable by S-Bahn and train, and of course by car.',
  locHL5Title: 'Easy to reach',
  locHL5Text: 'Free parking, motorway access (A95/Garmisch, A96/Lindau) and the S-Bahn within walking distance.',
  locDist1: 'Munich main station',
  locDist2: 'Lake Starnberg',
  locDist3: 'Munich Airport',
  locDist4: 'Zugspitze',

  // Contact
  contactTitle: 'Contact & directions',
  contactLead: 'We look forward to your enquiry – contact us to book your stay at Hotel Alpenhof Gauting.',
  contactBookTitle: 'Book online',
  contactBookSub: 'Check availability & book directly',
  contactBookCta: 'Go to the full booking page',
  contactBookPhone: 'Or by phone:',
  contactNoRoom: 'No room available? We often still have options for stays of 3 nights or more.',
  contactNoRoomLink: 'Get in touch with us directly.',
  contactInfoTitle: 'Contact details',
  contactAddress: 'Address',
  contactAddressLines: 'Hotel Alpenhof Gauting\nUnterbrunner Straße 9\n82131 Gauting (near Munich)',
  contactPhone: 'Phone',
  contactEmail: 'Email',
  contactArrivalTitle: 'How to find us',
  contactCarTitle: 'By car',
  contactCarText: 'A96 Munich – Lindau, exit Unterpfaffenhofen/Germering, or A95 Munich – Garmisch, exit Starnberg, then towards Gauting through the romantic, winding Würmtal valley.',
  contactTrainTitle: 'By S-Bahn',
  contactTrainText: 'S6 to Gauting (25 minutes from Munich main station). The hotel is a 7-minute walk from the station.',

  // CTA Banner
  ctaKicker: 'A stay at the Alpenhof',
  ctaTitle: 'One holiday. Many possibilities.',
  ctaText: 'Whether a short break, a weekend trip or a longer stay – the Alpenhof offers the right setting for restful and varied days.',
  ctaButton: 'Book now',
};
